import config from '.././Config';
//import { headers } from '../types/Headers';

export const prepareHeaders = (token: string) => {
    var header: any = {
        accept: 'application/json',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        token: token,
        client_id: config.oidc.clientId,
    };
    return header;
};

export const getHeaders = (token: string, clientId: string, groupName: string = '') => {
    var header: any = {
        accept: 'application/json',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        token: token,
        client_id: config.oidc.clientId,
    };
    return header;
};
